<template>
  <section id="home">
    <main>
      <div class="menu">
        <div class="ico-container">
          <div class="menu-item" @click="$router.push('/trucks')">
            <span class="wrapper">
              <icon icoClass='menu-ico' selected='trucks' display='table-row' />
              <div class="menu-name">{{ $t('trucks') }}</div>
            </span>
          </div>
          <div class="menu-item" @click="$router.push('/expeditions')">
            <span class="wrapper">
              <icon icoClass='menu-ico' selected='expeditions' display='table-row' />
              <div class="menu-name">{{ $t('expeditions') }}</div>
            </span>
          </div>
          <div class="menu-item" @click="$router.push('/receptions')">
            <span class="wrapper">
              <icon icoClass='menu-ico' selected='receptions' display='table-row' />
              <div class="menu-name">{{ $t('receptions') }}</div>
            </span>
          </div>
          <div class="menu-item" @click="$router.push('/critical-lines')" v-if="isTrw">
            <span class="wrapper">
              <icon icoClass='menu-ico' selected='criticalLines' display='table-row' />
              <div style='font-size:0.8em !important;' class="menu-name">{{ $t('critical_lines') }}</div>
            </span>
          </div>
          <div class="menu-item" @click="$router.push('/task-list')"
            v-if="((isTrw && companyCode === 'kl') || !isTrw) && canSeeTaskList">
            <span class="wrapper">
              <icon icoClass='menu-ico' selected='tasklist' display='table-row' />
              <div style='font-size:0.8em !important;' class="menu-name">{{ $t('task_list') }}</div>
            </span>
          </div>
          <div class="menu-item" @click="$router.push('/bi')">
            <span class="wrapper">
              <icon icoClass='menu-ico' selected='bi' display='table-row' />
              <div class="menu-name">{{ $t('bi') }}</div>
            </span>
          </div>
          <div class="menu-item" v-if="!isTrw">
            <span class="wrapper">
              <icon icoClass='menu-ico' selected='import' display='table-row' />
              <div class="menu-name">{{ $t('import') }}</div>
            </span>
          </div>
          <div class="menu-item" v-if="!isTrw">
            <span class="wrapper">
              <icon icoClass='menu-ico' selected='export' display='table-row' />
              <div class="menu-name">{{ $t('export') }}</div>
            </span>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import icon from './../svg/tabs'
export default {
  name: 'home',
  components: { icon },
  props: {},
  created () {
    this.$emit('loading')
  },
  mounted () {
    this.checkPermissionsAndCompany()
  },
  data () {
    return {
      companyCode: process.env.COMPANY,
      canSeeTaskList: false,
      isTrw: false
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      companyId: state => state.auth.company
    })
  },
  watch: {
    companyId (newVal) {
      if (newVal) {
        this.getCompany({ id: newVal }).then(response => {
          this.isTrw = response[0].is_trw
        })
      }
    }
  },
  methods: {
    ...mapActions({
      hasPermission: 'auth/hasPermission',
      getCompany: 'listes/company'
    }),
    async checkPermissionsAndCompany () {
      try {
        const permissionResponse = await this.hasPermission('seeTasklist')
        this.canSeeTaskList = permissionResponse
        if (this.companyId) {
          const companyResponse = await this.getCompany({ id: this.companyId })
          this.isTrw = companyResponse && companyResponse.length > 0 ? companyResponse[0].is_trw : this.isTrw
        }
      } catch (error) {
        console.error('Error checking permissions and company:', error)
      } finally {
        this.$emit('loaded')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/variables.scss';

#home {
  border: none;
}

.app-title {
  color: $k-lime;
  font-size: 1.5em;
  min-width: 5.2em;
}

.ico-container {
  max-width: 750px;
  margin: 3em auto;
  text-align: center;
}

.menu {
  display: block;
  text-transform: uppercase;
  font-family: MuseoSans-700;

  .menu-item {
    width: 150px;
    height: 150px;
    font-size: 1.1em;
    padding: 1em;
    background: $k-lime;
    border-radius: 6%;
    margin: .5em;
    transition: .4s;
    position: relative;
    cursor: pointer;
    vertical-align: top;
    display: inline-block;
    text-align: center;

    &:hover {
      background: $k-turq;
    }

    .wrapper {
      display: table;
      width: 100%;
      height: 100%;

      .menu-name {
        display: table-cell;
        vertical-align: bottom;
      }
    }
  }
}

//for tv
@media screen and (min-width: 2000px) {
  .menu {
    .menu-item {
      width: calc(150px + 6vw);
      height: calc(150px + 6vw);
      font-size: 1.1em;
      padding: 1em;
      margin: .5em;

      .wrapper {
        width: 100%;
        height: 100%;
      }
    }
  }

  .ico-container {
    max-width: calc((150px + 6vw) * 5);
    font-size: .8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageHome.vue